export default "__VITE_ASSET__BwVlbiIa__"